module.exports = __webpack_public_path__ + "img/1.62d21f02.png";